import React from 'react';
import Text from '../Base/Text/Text';
import { useFormContext } from 'react-hook-form';
import useNotification from '../../Hooks/useNotification.hook';
import useTranslation from '../../Hooks/useTranslation';
import { useValidation } from '../Utils/Validation';
import { FormValues } from '../../Modules/MagicForm/Interfaces/FormValues';

export interface SubmitButtonProps {
	onSubmit: (values: FormValues) => any;
	disabled?: boolean;
	title?: string;
	className?: any;
}

const SubmitButton = (props: SubmitButtonProps) => {
	const { onSubmit, title = 'base.create', className, disabled } = props;
	const { t } = useTranslation();
	const { messageFilled } = useValidation();

	const { showNotificationAlert } = useNotification();
	const { handleSubmit, getValues } = useFormContext();

	const resolveErrorMessage = (error: any) => {
		if (!error) return;

		if (typeof error?.message !== 'undefined') {
			let errorMessage = t(error?.message?.toString());
			if (['is-required-select', 'required'].indexOf(error?.type) !== -1) {
				errorMessage = messageFilled(errorMessage || '');
			}
			if (errorMessage) {
				showNotificationAlert({
					content: errorMessage,
				});
			}
		} else {
			if (Array.isArray(error)) {
				for (let i = 0; i < error.length; i++) {
					resolveErrorMessage(error[i]);
				}
			} else {
				for (const key of Object.keys(error)) {
					resolveErrorMessage(error[key]);
				}
			}
		}
	};

	const handlePress = () => {
		if (disabled) return;

		if (typeof onSubmit === 'function') {
			handleSubmit(
				values => {
					console.log('✅ Úspěšně validováno, hodnoty:', values);
					onSubmit(values);
				},
				errors => {
					console.log('❌ Chyby validace:', errors);
					console.log('📋 Hodnoty při chybné validaci:', getValues());
					for (const key in errors) {
						resolveErrorMessage(errors[key]);
					}
				},
			)();
		}
	};

	return (
		<button
			className={className || 'btn btn-green-global remastered'}
			type='button'
			onClick={handlePress}
			disabled={disabled}>
			{title && <Text tx={title} inline={true} firstUpper={true} />}
		</button>
	);
};

export default SubmitButton;
